import store from '../store'
import axios from 'axios'

const state = {
  omisePublicKey: process.env.NODE_ENV === 'production' ? 'pkey_57827yfp962v2ipxauu' : 'pkey_test_56pdg64qgwyzltkad0y',
  omiseSecurePublicKey: process.env.NODE_ENV === 'production' ? 'pkey_52yd8nj3qqmuyeqz47e' : 'pkey_test_52u4qcm2dmtsrisa1sm',
  customerApiUrl: process.env.NODE_ENV === 'production' ? 'https://lumen.beneat.co' : 'https://beneat-test.com',
  adminBaseApiUrl: process.env.NODE_ENV === 'production' ? 'https://lumen-admin.beneat.co' : 'https://api-admin.beneat-test.com',
  cities: null,
  citiesLocations: null,
  placeSizes: null,
  activityTypes: null,
  services: null,
  subscriptionServices: null,
  provinceWages: null,
  provinceDiscounts: null,
  petTypes: null,
  extras: null,
  subscriptionTypes: null,
  packageTypes: null,
  configData: null,
  bankAccountData: null,
  professionalTipData: null,
  languages: null,
  displayFBChat: true,
  prefixName: ['นาย', 'นาง', 'นางสาว'],
  durations: {
    1: 'message.duration.01',
    2: 'message.duration.02',
    3: 'message.duration.03',
    4: 'message.duration.04',
    5: 'message.duration.05',
    6: 'message.duration.06',
    7: 'message.duration.07',
    8: 'message.duration.08'
  },
  placeSizeWorkHours: {
    1: '2.0',
    2: '2.5',
    3: '3.0',
    4: '3.5',
    5: '3.0',
    6: '4.0',
    7: '8.0',
    8: '2.0'
  },
  workHours: {
    '2.0': 'message.work_hours.01',
    '2.5': 'message.work_hours.02',
    '3.0': 'message.work_hours.03',
    '3.5': 'message.work_hours.04',
    '4.0': 'message.work_hours.05',
    '4.5': 'message.work_hours.06',
    '6.0': 'message.work_hours.09',
    '8.0': 'message.work_hours.13'
  },
  allWorkHours: {
    '2.0': 'message.work_hours.01',
    '2.5': 'message.work_hours.02',
    '3.0': 'message.work_hours.03',
    '3.5': 'message.work_hours.04',
    '4.0': 'message.work_hours.05',
    '4.5': 'message.work_hours.06',
    '5.0': 'message.work_hours.07',
    '5.5': 'message.work_hours.08',
    '6.0': 'message.work_hours.09',
    '6.5': 'message.work_hours.10',
    '7.0': 'message.work_hours.11',
    '7.5': 'message.work_hours.12',
    '8.0': 'message.work_hours.13',
    '8.5': 'message.work_hours.14',
    '9.0': 'message.work_hours.15',
    '9.5': 'message.work_hours.16'
  },
  times: {
    '07:00': '07:00',
    '07:30': '07:30',
    '08:00': '08:00',
    '08:30': '08:30',
    '09:00': '09:00',
    '09:30': '09:30',
    '10:00': '10:00',
    '10:30': '10:30',
    '11:00': '11:00',
    '11:30': '11:30',
    '12:00': '12:00',
    '12:30': '12:30',
    '13:00': '13:00',
    '13:30': '13:30',
    '14:00': '14:00',
    '14:30': '14:30',
    '15:00': '15:00',
    '15:30': '15:30',
    '16:00': '16:00',
    '16:30': '16:30',
    '17:00': '17:00',
    '17:30': '17:30',
    '18:00': '18:00',
    '18:30': '18:30',
    '19:00': '19:00',
    '19:30': '19:30'
  },
  arrTimes: [
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30'
  ],
  arrFullTimes: [
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00'
  ],
  months: [
    { name: 'มกราคม', shortName: 'ม.ค.', shortNameEn: 'Jan', nameEn: 'January', month: 1 },
    { name: 'กุมภาพันธ์', shortName: 'ก.พ.', shortNameEn: 'Feb', nameEn: 'February', month: 2 },
    { name: 'มีนาคม', shortName: 'มี.ค.', shortNameEn: 'Mar', nameEn: 'Mar', month: 3 },
    { name: 'เมษายน', shortName: 'เม.ย.', shortNameEn: 'Apr', nameEn: 'April', month: 4 },
    { name: 'พฤษภาคม', shortName: 'พ.ค.', shortNameEn: 'May', nameEn: 'May', month: 5 },
    { name: 'มิถุนายน', shortName: 'มิ.ย.', shortNameEn: 'Jun', nameEn: 'June', month: 6 },
    { name: 'กรกฎาคม', shortName: 'ก.ค.', shortNameEn: 'Jul', nameEn: 'July', month: 7 },
    { name: 'สิงหาคม', shortName: 'ส.ค.', shortNameEn: 'Aug', nameEn: 'August', month: 8 },
    { name: 'กันยายน', shortName: 'ก.ย.', shortNameEn: 'Sep', nameEn: 'September', month: 9 },
    { name: 'ตุลาคม', shortName: 'ต.ค.', shortNameEn: 'Oct', nameEn: 'October', month: 10 },
    { name: 'พฤศจิกายน', shortName: 'พ.ย.', shortNameEn: 'Nov', nameEn: 'November', month: 11 },
    { name: 'ธันวาคม', shortName: 'ธ.ค.', shortNameEn: 'Dec', nameEn: 'December', month: 12 }
  ],
  currentLoginPath: null,
  currentLanguage: 'th',
  serviceVat: 0.07
}

const actions = {
  LOAD_GLOBAL_DATA: async ({ commit }, queryData) => {
    const url = 'global-data'
    let { data } = await axios.get(url, { params: queryData })
    if (data) {
      const response = data
      if (!response.error) {
        // console.log('global data response', response)
        commit('SET_PROVINCE_DATA', response.provinces)
        commit('SET_PROVINCE_WAGES', response.province_wages)
        commit('SET_PROVINCE_DISCOUNTS', response.province_discounts)
        commit('SET_PLACE_SIZE_DATA', response.place_sizes)
        // commit('SET_ACTIVITY_TYPE_DATA', response.activity_types)
        commit('SET_SERVICE_DATA', response.services)
        commit('SET_SUBSCRIPTION_SERVICES', response.subscription_services)
        commit('SET_SERVICE_VAT', response.service_vat)
        commit('SET_PET_TYPES', response.pet_types)
        commit('SET_EXTRAS', response.extras)
        commit('SET_SUBSCRIPTION_TYPES', response.subscription_types)
        commit('SET_PACKAGE_TYPES', response.package_types)
        commit('SET_CONFIG_DATA', response.config_data)
        commit('SET_BANK_ACCOUNT_DATA', response.bank_account_data)
        commit('SET_PROFESSIONAL_TIP_DATA', response.professional_tip_data)
        commit('SET_LANGUAGES', response.languages)
        // Set jwt token in auth
        if (response.jwt_token) {
          store.commit('auth/SET_TOKEN', response.jwt_token)
        }
      }
    }
  }
}

const mutations = {
  SET_CURRENT_LOGIN_PATH: (state, pageName) => {
    state.currentLoginPath = pageName
  },
  SET_PROVINCE_DATA: (state, data) => {
    let cities = {}
    let citiesLocations = {}
    for (let key in data) {
      const id = data[key].id
      cities[id] = {
        id: data[key].id,
        name_th: data[key].name_th,
        name_en: data[key].name_en,
        accepted_distance: data[key].accepted_distance
      }
      citiesLocations[id] = {
        id: data[key].id,
        lat: data[key].latitude,
        lng: data[key].longitude
      }
    }
    state.cities = cities
    state.citiesLocations = citiesLocations
  },
  SET_PROVINCE_WAGES: (state, data) => {
    let provinceWages = {}
    for (let key in data) {
      const id = data[key].id
      provinceWages[id] = {
        id: data[key].id,
        cost_per_hour: Number(data[key].wage)
      }
    }
    state.provinceWages = provinceWages
  },
  SET_PROVINCE_DISCOUNTS: (state, data) => {
    let provinceDiscounts = []
    for (let key in data) {
      const provinceDiscount = {
        province_id: data[key].province_id,
        work_hour: parseFloat(data[key].work_hour).toFixed(1),
        discount: data[key].discount
      }
      provinceDiscounts.push(provinceDiscount)
    }
    state.provinceDiscounts = provinceDiscounts
  },
  SET_PLACE_SIZE_DATA: (state, data) => {
    let placeSizes = {}
    for (let key in data) {
      const id = data[key].id
      placeSizes[id] = {
        id: data[key].id,
        name_th: data[key].name_th,
        name_en: data[key].name_en,
        cleaning_duration: data[key].cleaning_duration
      }
    }
    state.placeSizes = placeSizes
  },
  SET_ACTIVITY_TYPE_DATA: (state, data) => {
    let activityTypes = {}
    for (let key in data) {
      const id = data[key].id
      activityTypes[id] = {
        id: data[key].id,
        name_th: data[key].name_th,
        name_en: data[key].name_en
      }
    }
    state.activityTypes = activityTypes
  },
  SET_SERVICE_DATA: (state, data) => {
    let services = {}
    for (let key in data) {
      const id = data[key].id
      services[id] = data[key]
    }
    state.services = services
  },
  SET_CURRENT_LANGUAGE: (state, language) => {
    state.currentLanguage = language
  },
  SET_SERVICE_VAT: (state, serviceVat) => {
    state.serviceVat = serviceVat
  },
  SET_PET_TYPES: (state, petTypes) => {
    state.petTypes = petTypes
  },
  SET_EXTRAS: (state, extras) => {
    state.extras = extras
  },
  SET_SUBSCRIPTION_TYPES: (state, subscriptionTypes) => {
    state.subscriptionTypes = subscriptionTypes
  },
  SET_PACKAGE_TYPES: (state, packageTypes) => {
    state.packageTypes = packageTypes
  },
  SET_SUBSCRIPTION_SERVICES: (state, subscriptionServices) => {
    state.subscriptionServices = subscriptionServices
  },
  SET_CONFIG_DATA: (state, configData) => {
    state.configData = { ...configData }
  },
  SET_DISPLAY_FACEBOOK_CHAT: (state, value) => {
    state.displayFBChat = value
  },
  SET_BANK_ACCOUNT_DATA: (state, data) => {
    state.bankAccountData = data
  },
  SET_PROFESSIONAL_TIP_DATA: (state, data) => {
    state.professionalTipData = data
  },
  SET_LANGUAGES: (state, languages) => {
    state.languages = languages
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.val.js